exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#headerCntr .storeLocation {\n  position: absolute;\n  top: 50px;\n  left: 81px;\n  color: #333;\n}\n\n/* ### header container ### */\n#headerCntr { position: relative; width: 100%; height: 80px; }\n#headerCntr .logo { position: absolute; top: 10px; left: 0px; }\n#headerCntr .text { position: absolute; top: 31px; font-size: 15px; font-weight: bold; color: #333; left: 81px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/header/header.component.css
// module id = ../../../../../src/app/shared/header/header.component.css
// module chunks = main